import { useSelector } from "react-redux";
import Button from "../../../components/UI/Button/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getSstAttachment,
  getSstEvent,
  getSstEventAttachments,
} from "../../../axios/requests/qas";
import { toast } from "react-toastify";
import SmallLoading from "../../Loading/SmallLoading";
import ModalInsert from "./ModalInsert";
import { toAbsoluteUrl } from "../../../components/_metronic/helpers";
import LabelState from "../../../components/UI/LabelState/LabelState";

interface Event {
  id: number;
  titulo: string;
  descricao: string;
  imagem: string;
  data_inicio: string;
  data_fim: string;
}

interface Attachment {
  id: number;
  id_colaborador: number;
  id_evento: number;
  idade_autor: number;
  nome_autor: string;
  nome_ficheiro: string;
  extensao: string;
  data_upload: string;
}

const EventSst: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const location = useLocation().pathname;

  const params = useParams().id!;

  const [event, setEvent] = useState<Event | null>(null);
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const [selectedAttachment, setSelectedAttachment] = useState<number | null>(
    null
  );

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingAttachments, setLoadingAttachments] = useState<boolean>(true);
  const [loadingFile, setLoadingFile] = useState<boolean>(false);

  const [showModal, setShowModal] = useState<boolean>(false);

  const [file, setFile] = useState<string>("");

  async function getEvent() {
    try {
      setLoading(true);
      const response = await getSstEvent(user.accessToken, +params);
      setEvent(response.data);
    } catch (err: any) {
      toast.error("Não foi possível encontrar o ficheiro");
      navigate("/");
    } finally {
      setLoading(false);
    }
  }

  async function getEventAttachments() {
    try {
      setLoadingAttachments(true);
      const response = await getSstEventAttachments(
        user.accessToken,
        +params,
        user.id_colaborador
      );

      if (!selectedAttachment && response.data.length > 0) {
        setSelectedAttachment(0);
      }
      setAttachments(response.data);
    } catch (err) {
    } finally {
      setLoadingAttachments(false);
    }
  }

  async function getFile() {
    if (attachments[selectedAttachment!].id || event?.id) {
      try {
        setLoadingFile(true);

        const response = await fetch(
          `${process.env.REACT_APP_FTP_FOLDER_QAS_SST_EVENTOS}${event?.id}/${
            user.id_colaborador
          }/${attachments[selectedAttachment!].id}.${
            attachments[selectedAttachment!].extensao
          }`
        );

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const attachment = attachments[selectedAttachment!];
        const ext = attachment.extensao.toLowerCase();

        if (ext === "pdf") {
          setFile(url);
        }
      } catch (err) {
        console.log(err);
        toast.error("Ocorreu um erro ao carregar o ficheiro");
      } finally {
        setLoadingFile(false);
      }
    }
  }

  function detailsAttachment(index: number | null, param: string) {
    if (index === null) {
      return null;
    }
    const annex = (attachments[index] as any)[param];

    return annex;
  }

  useEffect(() => {
    if (
      selectedAttachment != null &&
      attachments.length &&
      attachments[selectedAttachment]?.extensao === "pdf"
    ) {
      getFile();
    }
  }, [selectedAttachment, attachments]);

  useEffect(() => {
    getEvent();
    getEventAttachments();
  }, []);

  return (
    <div>
      <ModalInsert
        isOpen={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
        event_id={+params}
        getEventAttachments={getEventAttachments}
      />
      {user.id_user ? (
        <>
          {!loading ? (
            <>
              {event ? (
                <>
                  <div className="flex flex-col justify-content-center mt-10 text-center">
                    <h1 className="">{event.titulo}</h1>
                    <span
                      className="mt-10"
                      dangerouslySetInnerHTML={{
                        __html: event.descricao,
                      }}
                    ></span>
                  </div>
                  <div className=" mt-10 d-flex justify-content-center">
                    <Button
                      onClick={() => {
                        setShowModal(true);
                      }}
                      title="Submeter desenho"
                      icon="FileArrowUp"
                    />
                  </div>
                  <hr className="my-10 " />
                  <div className="d-flex flex-wrap">
                    {!loadingAttachments ? (
                      <div className="col-12 col-md-6">
                        <h2>Desenhos submetidos</h2>
                        {attachments.length > 0 ? (
                          <div className="d-flex flex-column mt-10 w-100">
                            {attachments?.map((attachment, index) => {
                              return (
                                <div className="w-100" key={index}>
                                  <div className="d-flex mt-3 justify-content-between w-100 ">
                                    <div className="d-flex flex-column">
                                      <div className="d-flex gap-3 align-items-center">
                                        <span className="fw-bold fs-3">
                                          {attachment.nome_autor || "-"}
                                        </span>
                                        {index == selectedAttachment ? (
                                          <div>
                                            <LabelState
                                              name={"Selecionado"}
                                              color={"var(--primary)"}
                                              textSize="11px"
                                              padding="px-2 py-0.5"
                                            />
                                          </div>
                                        ) : null}
                                      </div>
                                      <span className=" fs-6 mt-1 text-muted">
                                        {attachment.idade_autor || "-"}
                                        {attachment.idade_autor == 1
                                          ? " ano de idade"
                                          : attachment.idade_autor > 1
                                          ? " anos de idade"
                                          : ""}
                                      </span>
                                    </div>
                                    <Button
                                      style="btn btn-tertiary"
                                      title="Ver desenho"
                                      onClick={() => {
                                        setSelectedAttachment(index);
                                      }}
                                      disabled={index === selectedAttachment}
                                    />
                                  </div>
                                  {attachments?.length - 1 !== index ? (
                                    <hr className="my-3" />
                                  ) : null}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center  h-100">
                            <div className="d-flex flex-column align-items-center">
                              <span className="fw-bolder fs-5">
                                Ainda não existem desenhos submetidos
                              </span>
                              <span className=" fs-7 mt-5 text-center">
                                Convide os mais novos a participar no desafio
                                {`" ${event.titulo}"`}. Seja o primeiro a
                                submeter um desenho e inspire os colegas!
                              </span>
                              <Button
                                onClick={() => {
                                  setShowModal(true);
                                }}
                                title="Submeter desenho"
                                icon="FileArrowUp"
                                space="mt-5"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center">
                        <SmallLoading />
                      </div>
                    )}
                    <div className="col-12 col-md-6 p-5">
                      <div
                        style={{
                          height:
                            detailsAttachment(
                              selectedAttachment,
                              "extensao"
                            ) === "pdf"
                              ? "500px"
                              : "",
                        }}
                        className="card card-border"
                      >
                        {!attachments.length ? (
                          <img
                            src={toAbsoluteUrl("/uploads/pdc/desenhos-qas.jpg")}
                            alt="image-sst"
                          />
                        ) : null}
                        {!loadingFile ? (
                          <>
                            {attachments.length ? (
                              <>
                                {detailsAttachment(
                                  selectedAttachment,
                                  "extensao"
                                ) === "pdf" ? (
                                  <iframe
                                    src={file}
                                    style={{ width: "100%", height: "100%" }}
                                    title="pdf-sst"
                                  />
                                ) : (
                                  <img
                                    src={detailsAttachment(
                                      selectedAttachment,
                                      "file_url"
                                    )}
                                    alt="image-sst"
                                  />
                                )}
                                <div className="d-flex justify-content-between mt-10">
                                  <div className="d-flex flex-column">
                                    <span className="fw-bold fs-5">
                                      {detailsAttachment(
                                        selectedAttachment,
                                        "nome_autor"
                                      ) || "-"}
                                    </span>
                                    <span className=" fs-5">
                                      {detailsAttachment(
                                        selectedAttachment,
                                        "idade_autor"
                                      ) || "-"}{" "}
                                      {detailsAttachment(
                                        selectedAttachment,
                                        "idade_autor"
                                      ) === 1
                                        ? " ano de idade"
                                        : detailsAttachment(
                                            selectedAttachment,
                                            "idade_autor"
                                          ) &&
                                          detailsAttachment(
                                            selectedAttachment,
                                            "idade_autor"
                                          ) > 1
                                        ? " anos de idade"
                                        : ""}
                                    </span>
                                  </div>
                                  <div className="d-flex gap-2">
                                    <Button
                                      icon="CaretLeft"
                                      style="btn btn-secondary"
                                      disabled={selectedAttachment === 0}
                                      onClick={() => {
                                        if (
                                          selectedAttachment &&
                                          selectedAttachment > 0
                                        ) {
                                          setSelectedAttachment(
                                            selectedAttachment - 1
                                          );
                                        }
                                      }}
                                    />
                                    <Button
                                      icon="CaretRight"
                                      style="btn btn-secondary"
                                      disabled={
                                        !(selectedAttachment != null) ||
                                        selectedAttachment >=
                                          attachments.length - 1
                                      }
                                      onClick={() => {
                                        if (
                                          selectedAttachment != null &&
                                          selectedAttachment <
                                            attachments.length - 1
                                        ) {
                                          setSelectedAttachment(
                                            selectedAttachment + 1
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}
                          </>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <SmallLoading />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </>
          ) : (
            <div className="flex justify-center mt-5">
              <SmallLoading />
            </div>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-center">
          <div className="d-flex flex-column">
            <p className="fs-4 fw-bold">
              Inicie sessão para ter acesso aos eventos SST
            </p>
            <div className="d-flex justify-content-center">
              <Button
                title="Iniciar Sessão"
                onClick={() => {
                  navigate(`/login?path=${location}`);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventSst;
